// The screens this app has, generated from .appfactory/product-plan.json.
//
// Imported by the navigation shell rather than replacing it: the shell owns
// router.js — bottom-tabs, stack and sidebar produce different routers, and it
// rewrites that file on every `spec apply`. Two owners for one file is a silent
// fight, so the product contributes ROUTES and the shell decides what to do
// with them.
//
// `primary` marks a screen that earns a place in the navigation itself.

import TaskListPage from './pages/TaskListPage.vue';
import TaskFormPage from './pages/TaskFormPage.vue';
import SettingsPage from './pages/SettingsPage.vue';
import TaskDetailPage from './pages/TaskDetailPage.vue';
import LogEntryPage from './pages/LogEntryPage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'task-list',
    path: '/',
    label: 'Last Time I…',
    component: TaskListPage,
    primary: true,
  },
  {
    id: 'task-form',
    path: '/tasks/new',
    label: 'Add or edit task',
    component: TaskFormPage,
    primary: false,
  },
  {
    id: 'settings',
    path: '/settings',
    label: 'Settings',
    component: SettingsPage,
    primary: false,
  },
  {
    id: 'task-detail',
    path: '/tasks/:id',
    label: 'Task detail',
    component: TaskDetailPage,
    primary: false,
  },
  {
    id: 'log-entry',
    path: '/tasks/:id/log',
    label: 'Log or edit an entry',
    component: LogEntryPage,
    primary: false,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
